module.exports =
    {
      ga4Code:"G-QYT05G1PVL"      
    }  